export const isCoupledReturn = (returnType) => { 
    return returnType === 'coupled';
}

export const isQuebecResident = (province) => { 
    return province === 'QC';
}

